import React, { useEffect, useState } from 'react';
import { LOCALE_KEY } from '@fx-ui/intl';
import { Intl } from '../../constants';
import { GlobalStateInitConfig, globalState } from '../../models';
// jdy-biz初始化
import { ConfigProvider as BizConfigProvider } from '@fx-ui/jdy-design-biz';
import BIZ_ZH_CN from '@fx-ui/jdy-design-biz/locale/zh_CN';
import BIZ_ZH_TW from '@fx-ui/jdy-design-biz/locale/zh_TW';
import BIZ_EN_US from '@fx-ui/jdy-design-biz/locale/en_US';
import BIZ_JA_JP from '@fx-ui/jdy-design-biz/locale/ja_JP';
import BIZ_VI_VN from '@fx-ui/jdy-design-biz/locale/vi_VN';
import BIZ_RU_RU from '@fx-ui/jdy-design-biz/locale/ru_RU';
import BIZ_FR_FR from '@fx-ui/jdy-design-biz/locale/fr_FR';
import BIZ_ES_ES from '@fx-ui/jdy-design-biz/locale/es_ES';
import BIZ_TH_TH from '@fx-ui/jdy-design-biz/locale/th_TH';
import BIZ_ID_ID from '@fx-ui/jdy-design-biz/locale/id_ID';
import BIZ_KO_KR from '@fx-ui/jdy-design-biz/locale/ko_KR';
import BIZ_DE_DE from '@fx-ui/jdy-design-biz/locale/de_DE';
import BIZ_PT_PT from '@fx-ui/jdy-design-biz/locale/pt_PT';
import BIZ_KM_KH from '@fx-ui/jdy-design-biz/locale/km_KH';
import BIZ_LO_LA from '@fx-ui/jdy-design-biz/locale/lo_LA';
import BIZ_HI_IN from '@fx-ui/jdy-design-biz/locale/hi_IN';
import BIZ_BN_BD from '@fx-ui/jdy-design-biz/locale/bn_BD';
import BIZ_TA_IN from '@fx-ui/jdy-design-biz/locale/ta_IN';
import BIZ_UZ_UZ from '@fx-ui/jdy-design-biz/locale/uz_UZ';
import BIZ_MN_MN from '@fx-ui/jdy-design-biz/locale/mn_MN';
import BIZ_IT_IT from '@fx-ui/jdy-design-biz/locale/it_IT';
import BIZ_NL_NL from '@fx-ui/jdy-design-biz/locale/nl_NL';
import BIZ_PL_PL from '@fx-ui/jdy-design-biz/locale/pl_PL';
import BIZ_HU_HU from '@fx-ui/jdy-design-biz/locale/hu_HU';
import BIZ_PT_BR from '@fx-ui/jdy-design-biz/locale/pt_BR';

const JDY_DESIGN_BIZ_LOCALE: Record<LOCALE_KEY, typeof BIZ_ZH_CN> = {
    [LOCALE_KEY.ZH_CN]: BIZ_ZH_CN,
    [LOCALE_KEY.ZH_TW]: BIZ_ZH_TW,
    [LOCALE_KEY.EN_US]: BIZ_EN_US,
    [LOCALE_KEY.JA_JP]: BIZ_JA_JP,
    [LOCALE_KEY.VI_VN]: BIZ_VI_VN,
    [LOCALE_KEY.RU_RU]: BIZ_RU_RU,
    [LOCALE_KEY.FR_FR]: BIZ_FR_FR,
    [LOCALE_KEY.ES_ES]: BIZ_ES_ES,
    [LOCALE_KEY.TH_TH]: BIZ_TH_TH,
    [LOCALE_KEY.ID_ID]: BIZ_ID_ID,
    [LOCALE_KEY.KO_KR]: BIZ_KO_KR,
    [LOCALE_KEY.DE_DE]: BIZ_DE_DE,
    [LOCALE_KEY.PT_PT]: BIZ_PT_PT,
    [LOCALE_KEY.KM_KH]: BIZ_KM_KH,
    [LOCALE_KEY.LO_LA]: BIZ_LO_LA,
    [LOCALE_KEY.HI_IN]: BIZ_HI_IN,
    [LOCALE_KEY.BN_BD]: BIZ_BN_BD,
    [LOCALE_KEY.TA_IN]: BIZ_TA_IN,
    [LOCALE_KEY.UZ_UZ]: BIZ_UZ_UZ,
    [LOCALE_KEY.MN_MN]: BIZ_MN_MN,
    [LOCALE_KEY.IT_IT]: BIZ_IT_IT,
    [LOCALE_KEY.NL_NL]: BIZ_NL_NL,
    [LOCALE_KEY.PL_PL]: BIZ_PL_PL,
    [LOCALE_KEY.HU_HU]: BIZ_HU_HU,
    [LOCALE_KEY.PT_BR]: BIZ_PT_BR
};

// 动态导入所有语言包
import zh_cn from '../../locales/zh_cn.json';
import zh_tw from '../../locales/zh_tw.json';
import en_us from '../../locales/en_us.json';
import ja_jp from '../../locales/ja_jp.json';
import vi_vn from '../../locales/vi_vn.json';
import th_th from '../../locales/th_th.json';
import id_id from '../../locales/id_id.json';
import ko_kr from '../../locales/ko_kr.json';
import pt_pt from '../../locales/pt_pt.json';
import ru_ru from '../../locales/ru_ru.json';
import fr_fr from '../../locales/fr_fr.json';
import es_es from '../../locales/es_es.json';
import de_de from '../../locales/de_de.json';
import km_kh from '../../locales/km_kh.json';
import lo_la from '../../locales/lo_la.json';
import hi_in from '../../locales/hi_in.json';
import bn_bd from '../../locales/bn_bd.json';
import ta_in from '../../locales/ta_in.json';
import uz_uz from '../../locales/uz_uz.json';
import mn_mn from '../../locales/mn_mn.json';
import it_it from '../../locales/it_it.json';
import nl_nl from '../../locales/nl_nl.json';
import pl_pl from '../../locales/pl_pl.json';
import hu_hu from '../../locales/hu_hu.json';
import pt_br from '../../locales/pt_br.json';

const localeMap: Record<LOCALE_KEY, any> = {
    zh_cn: zh_cn,
    zh_tw: zh_tw,
    en_us: en_us,
    ja_jp: ja_jp,
    vi_vn: vi_vn,
    th_th: th_th,
    id_id: id_id,
    ko_kr: ko_kr,
    pt_pt: pt_pt,
    ru_ru: ru_ru,
    fr_fr: fr_fr,
    es_es: es_es,
    de_de: de_de,
    km_kh: km_kh,
    lo_la: lo_la,
    hi_in: hi_in,
    bn_bd: bn_bd,
    ta_in: ta_in,
    uz_uz: uz_uz,
    mn_mn: mn_mn,
    it_it: it_it,
    nl_nl: nl_nl,
    pl_pl: pl_pl,
    hu_hu: hu_hu,
    pt_br: pt_br
};

export interface ConfigProviderProps extends GlobalStateInitConfig {
    /** 语言代码 */
    locale?: LOCALE_KEY;

    /** 子组件 */
    children: React.ReactElement;
}

/**
 * Open SDK 配置提供者
 * 负责初始化国际化、全局状态等
 */
const ConfigProvider: React.FC<ConfigProviderProps> = (props) => {
    const {
        locale = LOCALE_KEY.ZH_CN,
        site,
        basePath,
        tracker,
        request,
        authModel,
        children
    } = props;

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // 初始化全局状态
        globalState.init({
            site,
            basePath,
            tracker,
            request,
            authModel
        });

        // 初始化国际化
        const locales = localeMap[locale] || localeMap['zh_cn'];

        Intl.init(locale, locales);

        setLoading(false);
    }, []);

    if (loading) {
        return null;
    }

    return <BizConfigProvider locale={JDY_DESIGN_BIZ_LOCALE[locale]}>{children}</BizConfigProvider>;
};

export default ConfigProvider;
